import React from 'react';
import { useTranslation } from 'react-i18next';

import { useTouroperatorListAtom } from 'hooks/form/filter';
import { useMeta } from 'hooks/form/meta';
import { useChangedFilterList } from 'hooks/form/useChangedFilterList';
import { useBoUser } from 'hooks/useBoUser';
import { QaIdentifier } from 'hooks/useQa';

import { filterPredicateIsTruthy } from 'utility/Check/filterPredicateIsTruthy';

import Segment from '../Segment';
import { config } from '../Segment/config';

import TourOperatorList from './__partials/List';

const TourOperator = () => {
    const { t } = useTranslation();
    const [filterMeta] = useMeta();
    const [tourOperatorList, setTourOperatorList] = useTouroperatorListAtom();
    const isBoUser = useBoUser();
    const touroperatorData = filterMeta.tourOperator;
    const { onClear } = useChangedFilterList();

    const filterList = [...(TourOperatorList() ?? [])].filter(
        filterPredicateIsTruthy
    );

    if (!touroperatorData) {
        return null;
    }

    return (
        <Segment
            headline={{ text: t('TRANS-touroperator') }}
            withDeleteLink
            qaIdentifier={QaIdentifier.Search_Filter_Section_TourOperator}
            onDelete={() => {
                onClear(() => [...tourOperatorList]);
                setTourOperatorList(new Set());
            }}
            filterList={filterList}
            overflowThreshold={isBoUser ? 7 : config.overflowThreshold.default}
        />
    );
};

export default TourOperator;
